// extracted by mini-css-extract-plugin
export default {"description":"description_description__6m0uE"};